/**
 * Created by lu on 2018/5/8.
 */
var nb = require('../../nb');
var View = require('../../view/modal/cancelOrder');
// var successModl = require('./CancelOrderSucceed');
var getCancelOrder = require('../../io/' + process.env.APP_ENV + '/order/cancelOrder');  //取消订单
var OrderId, cause;
var Model = nb.define({
    parent: require('./Dialog'),
    mapping: {
        cancelList: require('../../model/form/RadioList')
    },
    method: {
        init: function () {
            var cancelList = this.get('cancelList');
            this.set('modalName', 'cancel-order');

            nb.model.onChange('changeLanguageReady', function (inEvent, inData) {
                if (inData == 'cn') {
                    this.set('title', '取消订单');
                } else {
                    this.set('title', 'Cancellation Of Order');
                }
            }, this);

            nb.model.onChange(nb.model.user, function (inEvent, inUser) {
                this._userId = parseInt(inUser.get('userId'));
                this._companyId = parseInt(inUser.get('companyId')); //companyId
            }, this);

            //点击取消订单
            nb.model.onChange('goCancelOrderId', function (inEvent, inId) {
                OrderId = inId;
            }, this);

            //获取取消订单原因
            cancelList.onChange('selectedValue', function (inEvent, inValue) {
                cause = parseInt(inValue);
            }, this);

            //点击提交
            this.onChange('cancelOrderCause', function () {
                var self = this;
                var suggest = this.get('suggest');
                getCancelOrder({
                    data: {
                        userId: this._userId,
                        orderId: OrderId,
                        companyId: this._companyId, //companyId
                        reasonId: cause,   //原因
                        reason: suggest
                    },
                    scope: this,
                    success: function (inResp) {
                        self.set('hide', new Date());
                        nb.model.set('cancelOrderSucceedState', inResp.msg)
                        // successModl.set('show', new Date())
                    }
                });

            }, this);

            this.onChange('onShow', function () {
                cancelList.set('activeIndex', 0);
            }, this);
        },
        setData: function () {
            return {
                cn: {
                    titleText: '温馨提示',
                    info: '订单取消成功后将无法恢复，请仔细考虑后在取消。',
                    cancelTitle: '请选择取消原因',
                    cancelBtn: '提交',
                    closeBtn: '再看看',
                    cancelList: {
                        items: [{
                            value: 1,
                            checked: true,
                            text: '订单不能按预计时间送达' //在线支付
                        }, {
                            value: 2,
                            text: '操作有误（商品／地址等选错）'
                        }, {
                            value: 3,
                            text: '重复下单／误下单'
                        }, {
                            value: 4,
                            text: '其他渠道价格更低'
                        }, {
                            value: 5,
                            text: '付款遇到问题'
                        }, {
                            value: 6,
                            text: '不想买了'
                        }]
                    },
                    titleText2: '其他原因',
                    otherReasons: '请填写取消订单的原因'
                },
                en: {
                    titleText: 'Notice',
                    info: 'After cancelled, the order will not be resumed. Please consider it carefully.',
                    cancelTitle: 'Reasons',
                    cancelBtn: 'Submit',
                    closeBtn: 'Close',
                    cancelList: {
                        items: [{
                            value: 1,
                            checked: true,
                            text: 'Orders can not be delivered on schedule.' //在线支付
                        }, {
                            value: 2,
                            text: 'Incorrect operation (merchandise / address, etc.)'
                        }, {
                            value: 3,
                            text: 'Double booking'
                        }, {
                            value: 4,
                            text: 'Other channels are cheaper.'
                        }, {
                            value: 5,
                            text: 'Payment problems'
                        }, {
                            value: 6,
                            text: 'I don\'t want to buy it'
                        }]
                    },
                    titleText2: 'Other Reason',
                    otherReasons: 'Please describe cancel reason.'
                }
            };
        }
    }
});
var model = new Model();
var view = new View;
view.setModel(model);
nb.model.onChange(nb.opts.clientReady, function () {
    view.$().appendTo(document.body);
}, this);

module.exports = model;

// , {
//     value: 7,
//         text: '其他原因'
// }


//////////////////
// WEBPACK FOOTER
// ../src/js/model/modal/CancelOrder.js
// module id = 172
// module chunks = 3 8